export enum PatientMenuItem {
  Info = "Podaci pacijenta",
  Programs = "Programi",
}
